import { ReactNode } from 'react';

interface SectionWrapperProps {
  id?: string;
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'muted';
}

export function SectionWrapper({
  id,
  children,
  className = '',
  variant = 'default',
}: SectionWrapperProps) {
  return (
    <section
      id={id}
      className={`py-16 sm:py-20 lg:py-24 ${
        variant === 'muted' ? 'bg-slate-50' : 'bg-white'
      } ${className}`}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6">{children}</div>
    </section>
  );
}
